// Setup namespaces
var Sitepackage = Sitepackage || {
    'Plugin': {
        'Notification': {}
    }
};


/**
 * Notification plugin.
 *
 * @class
 */
Sitepackage.Plugin.Notification = (function () {
    /**
     * Initializes the plugin.
     *
     * @param {Element} containers Main containers of this plugin
     *
     * @constructor
     */
    var Notification = function (containers) {
        const self = this;
        // Main container of this plugin
        this.containers = containers;

        // Contains all actions
        this.actions = {
            'list': []
        };

        // Event listeners
        this.listener = {
            'actionInitialized': []
        };

        // Each container will consist of a plugin action
        var actionContainer, action;

        this.containers.forEach(function (container) {

            actionContainer = container.querySelector('[data-action="list"]');
            if (actionContainer) {
                action = new Sitepackage.Plugin.Notification.ListAction(self, container, actionContainer);
                self.actions.list.push(action);
                self.dispatchEvent('actionInitialized', ['list', action]);
                return;
            }

        });
    };

    /**
     * Notifies the given event.
     *
     * @param {string} event Name of the event to notify
     * @param {Object} data (Optional) Data to pass to the listeners (defaults to nothing)
     *
     * @returns {void}
     */
    Notification.prototype.dispatchEvent = function (event, data) {
        if (!this.listener.hasOwnProperty(event)) {
            throw new Error('Event "' + event + '" does not exist.');
        }

        this.listener[event].forEach(function (callback) {
            callback(data);
        });
    };


    /**
     * Returns the main container of this plugin.
     *
     * @returns {Element}
     */
    Notification.prototype.getContainer = function () {
        return this.container;
    };


    return Notification;
})();

